import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Backdrop,
  CircularProgress,
  TextField,
  Stack,
  Button,
  Box
} from '@material-ui/core';

import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ChangeHistoryIcon from '@material-ui/icons/ChangeHistory';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'refId', label: 'Trans Date', alignRight: true },
  { id: 'date', label: 'Interest Date', alignRight: true },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'userName', label: 'Performed by', alignRight: false },
  { id: 'debit', label: 'Debit', alignRight: true },
  { id: 'credit', label: 'Credit', alignRight: true },
  // { id: 'arrears', label: 'Arrears', alignRight: true },
  // { id: 'balance', label: 'Balance', alignRight: true },
  { id: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function ProviderTransactions() {
  const { providerId } = useSettingContext();
  const [transactionList, setTransactions] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [balance, setBalance] = useState(0);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();
  const classes = useStyles();
  const zeroAmount = 0;

  useEffect(() => {
    if (providerId > 0) {
      getTransactions(providerId, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   // if (providerId > 0) {
  //   //   getTransactions(providerId, 0);
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [providerId]);

  const getTransactions = async (accountRefId, cycleDate) => {
    await axios(
      `${baseUrl}/api/accounting/GetTransactionsByAccountRef?accountRefId=${accountRefId}&cycleDate=${cycleDate}`
    ).then(
      (result) => {
        setTransactions(result.data);
      },
      (error) => {
        alert('failed');
      }
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const processAdjustment = (e) => {
    navigate(`/accounts/adjustments`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - transactionList.length) : 0;

  const filteredUsers = applySortFilter(transactionList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const totalCredit = transactionList
    .filter(({ sourceAction }) => sourceAction === 1)
    .reduce((sum, value) => sum + value.transactionAmount, 0);

  const totalDebit = transactionList
    .filter(({ sourceAction }) => sourceAction === 0)
    .reduce((sum, value) => sum + value.transactionAmount, 0);

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack direction="row" alignItems="right" justifyContent="end" mt="10" pt="3">
        <TextField
          size="small"
          id="currBalance"
          // label="Current Balance"
          InputProps={{
            inputComponent: Controls.NumberDecimal,
            style: { textAlign: 'right' }
          }}
          value={totalCredit - totalDebit}
        />
      </Stack>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table stickyHeader size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={transactionList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      refId,
                      interestDate,
                      transactionDate,
                      transactionAmount,
                      description,
                      userName,
                      arrears,
                      currentBalance,
                      sourceAction
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right" hidden>
                          {moment(transactionDate).isValid()
                            ? moment(transactionDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell component="th" scope="row" align="right" padding="none">
                          {moment(interestDate).isValid()
                            ? moment(interestDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{description}</TableCell>
                        <TableCell align="left">{userName}</TableCell>
                        <TableCell align="right">
                          {!sourceAction
                            ? transactionAmount.toLocaleString()
                            : zeroAmount.toLocaleString()}
                        </TableCell>
                        <TableCell align="right">
                          {sourceAction
                            ? transactionAmount.toLocaleString()
                            : zeroAmount.toLocaleString()}
                        </TableCell>
                        {/* <TableCell align="right">{arrears.toFixed(2)}</TableCell>
                        <TableCell align="right">{currentBalance.toFixed(2)}</TableCell> */}

                        <TableCell align="right">
                          <IconButton>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={transactionList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
      <Box mt={2}>
        <Button
          type="submit"
          variant="outlined"
          color="secondary"
          startIcon={<ChangeHistoryIcon />}
          onClick={() => processAdjustment()}
        >
          Process Adjustment
        </Button>
      </Box>
    </Container>
  );
}
